import { FormModal as Modal } from 'src/components/forms';
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useAgentChatAction from 'src/hooks/useAgentChatAction';
import { Box, Group, Progress } from '@mantine/core';
import { Button } from '@quantum-ecosystem/ui-toolkit';
import { Translate } from 'react-auto-translate';


const DialogContent = () => {

    const chatRequestData = useSelector((state) => state.agentChat.chatRequestData);
    const { acceptChatRequest, rejectChatRequest } = useAgentChatAction()
    const navigate = useNavigate()
    const [timer, setTimer] = useState(30)
    const timerRef = useRef(30)

    useEffect(() => {
        timerRef.current = timer

        return () => {

        }
    }, [timer])


    const handleAcceptClick = () => {
        acceptChatRequest()
        navigate("/mainpage/chat-support")
    }

    const handleRejectClick = useCallback(() => {
        rejectChatRequest()
    }, [rejectChatRequest])

    useEffect(() => {
        setTimer(30)
        const intervalId = setInterval(() => {
            if (timerRef.current > 1) {
                setTimer(prev => prev - 1)
            } else {
                handleRejectClick()
            }
        }, 1000)
        return () => {
            clearInterval(intervalId)
        }
    }, [handleRejectClick])


    return (
		<>
			<Box>
				<h6>{chatRequestData?.message}</h6>
				<div className="mt-2">
					<div className="d-flex align-items-center gap-1 justify-content-center">
						<p className="m-0">
							<Translate>
								Auto Reject in
							</Translate>
						</p>{' '}
						<h6 className="m-0">
							<Translate>
								{timer} {timer > 9 ? 'seconds' : 'second'}
							</Translate>
						</h6>
					</div>
					<Progress
						value={30 - timer}
						striped
						animated
						transitionDuration={200}
						aria-valuemin={0}
						aria-valuemax={30}
					/>
				</div>
			</Box>
			<Group mt="md" gap="xs" align="center" justify="flex-end">
				<Button
					variant="outline-danger"
					onClick={handleRejectClick}
				>
					<Translate>
						Reject
					</Translate>
				</Button>
				<Button variant="primary" onClick={handleAcceptClick}>
					<Translate>
						Accept
					</Translate>
				</Button>
			</Group>
		</>
	);
}


const AgentChatRequestDialog = () => {

    const isDialogOpen = useSelector((state) => state.agentChat.isDialogOpen);

    return (
		<Modal show={isDialogOpen} title="Incoming Chat Request" withCloseButton={false} centered>
			<DialogContent />
		</Modal>
	);
}

export default AgentChatRequestDialog